module.exports = __webpack_public_path__ + "img/cryo-chamber.49dbe94f.svg";